import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { EditIcon } from "../../../ui/icons/edit"
import { TrashIcon } from "../../../ui/icons/trash"
import { ButtonComponent } from "../../../ui/molecules/button/newButton"
import { PopupForm } from "../../../ui/organisms/popupForm"
import { activityOptions, attivita_bio, categorie_prodotti, formatterDate, normativa, optionsFormatter, regioniListOperativeAreas } from "../../../utils"
import { GetByIdPersonalManagement, resetGetByIdPersonalManagementResourcesStatus } from "../slice"
import { FunzioniPopupAdd } from "./boxPopupFunzioni/add"
import { FunzioniPopupEdit } from "./boxPopupFunzioni/edit"
import { DeleteFunction, GetFunctionById, addFunctionsInstance, resetCreationFunction, resetFunctionDeleteStatus, resetFunctionsInstance, resetGetFunctionByIdStatus, resetUpdateFunction, setPMId, setUpdateRequest } from "./slice"

export default function BoxFunzioni() {
    const dispatch = useAppDispatch()
    const functionsState = useAppSelector(state => state.PMFunctions)
    const PMState = useAppSelector(state => state.personalManagement)
    const [openPopup, setOpenPopup] = useState<boolean>(false)
    const [openPopupEdit, setOpenPopupEdit] = useState<boolean>(false)

    useEffect(() => {
        if (PMState.currentPersonalManagementId) {
            dispatch(resetFunctionsInstance())
            dispatch(setPMId(PMState.currentPersonalManagementId))
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId))
        }
    }, [PMState.currentPersonalManagementId])

    useEffect(() => {
        dispatch(resetFunctionsInstance())
        if (functionsState.functionCreationStatus === 'successfully' && PMState.currentPersonalManagementId) {
            dispatch(resetCreationFunction('idle'))
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId))
        }

    }, [functionsState.functionCreationStatus])

    useEffect(() => {
        dispatch(resetFunctionsInstance())
        if (functionsState.functionDeleteStatus === 'successfully' && PMState.currentPersonalManagementId) {
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId))
            dispatch(resetFunctionDeleteStatus())
        }

    }, [functionsState.functionDeleteStatus])

    useEffect(() => {

        if (functionsState.functionUpdateStatus === 'successfully' && PMState.currentPersonalManagementId) {
            dispatch(resetUpdateFunction('idle'))
            dispatch(resetFunctionsInstance())
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId))
        }

    }, [functionsState.functionUpdateStatus])

    useEffect(() => {

        dispatch(resetFunctionsInstance())
        if (PMState.getByIdPersonalManagementResourcesStatus === 'successfully' && PMState.getByIdPersonalManagementResourcesResponse?.functionIds) {
            dispatch(resetGetByIdPersonalManagementResourcesStatus('idle'))
            for (let index = 0; index < PMState.getByIdPersonalManagementResourcesResponse?.functionIds.length; index++) {
                dispatch(GetFunctionById(PMState.getByIdPersonalManagementResourcesResponse?.functionIds[index].toString()))
            }
        }

    }, [PMState.getByIdPersonalManagementResourcesStatus])

    useEffect(() => {
        if (functionsState.getFunctionByIdStatus === 'successfully' && PMState.getByIdPersonalManagementResourcesResponse) {
            dispatch(addFunctionsInstance(functionsState.GetFunctionById))
            dispatch(resetGetFunctionByIdStatus('idle'))
        }
    }, [functionsState.getFunctionByIdStatus])

    return (
        <div className="p-6">
            <div className="space-y-3">
                <div className="flex items-center justify-between">
                    <span className="font-bold text-2xl text-neutral-850">Funzioni</span>
                    <ButtonComponent
                        size="md"
                        iconPosition="off"
                        variant="solid"
                        color="orange"
                        label="Aggiungi Funzione"
                        onClick={() => setOpenPopup(true)}
                    />
                </div>
                <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                    <table id="customers-table" className="w-full border-collapse text-text-md min-w-[1100px]">
                        <thead>
                            <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Funzioni Assegnate</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Inizio</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Fine</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Norma</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Attività</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Categoria</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Aree Operative</th>
                                <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[72px]"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {functionsState.functionsInstances.length === 0 ? (
                                <tr>
                                    <td colSpan={8} className="px-3 py-3 text-left text-neutral-500 bg-white">
                                        Nessuna funzione trovata
                                    </td>
                                </tr>
                            ) : (
                                functionsState.functionsInstances.map((rowFunction, index) =>
                                    <tr
                                        className={`text-left border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                        key={rowFunction.id}
                                    >
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {optionsFormatter(rowFunction.assignedFunction!, activityOptions)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {formatterDate(rowFunction.startingFunction)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {formatterDate(rowFunction.endingFunction)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {optionsFormatter(rowFunction.norm!, normativa)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700">
                                            {
                                                rowFunction.functionActivities?.map((activity, activityIndex) => {
                                                    if (rowFunction.norm === 'NORMA_BIO') {
                                                        return <span key={`bio-activity-${activityIndex}`}> ({activity.bioActivity}) {optionsFormatter(activity.bioActivity!, attivita_bio)}</span>

                                                    } else if (rowFunction.norm === 'GLOBAL_GAP') {
                                                        return <span key={`gg-activity-${activityIndex}`}> {activity.ggStandard}</span>
                                                    }

                                                    return null
                                                }
                                                )
                                            }
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700">
                                            {rowFunction.functionActivities?.map((activity, activityIndex) => {
                                                if (rowFunction.norm === 'NORMA_BIO') {
                                                    if (activity?.bioCategories && Array.isArray(activity.bioCategories) && activity.bioCategories.length > 0) {
                                                        return activity.bioCategories.map((category, categoryIndex) => (
                                                            activity.bioCategories ? (
                                                                <span key={`bio-category-${activityIndex}-${categoryIndex}`}>
                                                                    {"(" + category + ") "} {optionsFormatter(category, categorie_prodotti)}
                                                                    {categoryIndex < activity.bioCategories.length - 1 && ' / '}
                                                                </span>
                                                            ) : null

                                                        ));
                                                    }
                                                } else if (rowFunction.norm === 'GLOBAL_GAP') {
                                                    return (
                                                        <span key={`gg-category-${activityIndex}`}>
                                                            {activity.ggIfaOption}
                                                        </span>
                                                    );
                                                }
                                                return null;
                                            })}
                                        </td>

                                        <td className="px-3 py-2 text-neutral-700">
                                            {
                                                rowFunction.operativesAreas.map((area, areaIndex) => {
                                                    const isLast = areaIndex === rowFunction.operativesAreas.length - 1;
                                                    return <span key={`${area}-${areaIndex}`}>
                                                        {optionsFormatter(area, regioniListOperativeAreas)}
                                                        {!isLast && ' / '}
                                                    </span>;
                                                })
                                            }
                                        </td>
                                        <td className="px-3 py-2 w-[72px]">
                                            <div className="flex items-center justify-center gap-2">
                                                <button
                                                    className="p-1 rounded hover:bg-neutral-100 transition-colors"
                                                    onClick={() => {
                                                        dispatch(setUpdateRequest(rowFunction))
                                                        setOpenPopupEdit(true)
                                                    }}
                                                >
                                                    <EditIcon color={"Orange"} size={18} />
                                                </button>

                                                <button
                                                    className="p-1 rounded hover:bg-neutral-100 transition-colors"
                                                    onClick={() => {
                                                        if (rowFunction.id) {
                                                            dispatch(DeleteFunction(rowFunction.id))
                                                        }
                                                    }
                                                    }
                                                >
                                                    <TrashIcon color={"Orange"} size={0} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            {
                openPopup && (
                    <PopupForm title="Aggiungi Funzione" close={() => {
                        setOpenPopup(false)
                    }}>
                        <FunzioniPopupAdd close={() => setOpenPopup(false)} />
                    </PopupForm>
                )
            }
            {
                openPopupEdit && (
                    <PopupForm title="Modifica Funzione" close={() => {
                        setOpenPopupEdit(false)
                    }}>
                        <FunzioniPopupEdit close={() => setOpenPopupEdit(false)} />
                    </PopupForm>
                )
            }
        </div >
    )
}